<div class="document-card d-flex align-items-center justify-content-between {{ rowClass }}">
	<div class="file-info col d-flex align-items-center overflow-hidden px-0">
		<div class="filename {{filenameClass}} d-flex align-items-center m-0">
			<mat-icon *ngIf="svgIcon; else defaultIcon" [svgIcon]="svgIcon"></mat-icon>
			<ng-template #defaultIcon>
				<mat-icon>description</mat-icon>
			</ng-template>
			<span class="file-name-text text-truncate">{{ text }}</span>
		</div>
	</div>
	<div class="actions col-auto d-flex align-items-center justify-content-end ml-auto ms-auto px-0">
		<button *ngIf="enableView && this.isViewFileType" type="button" mat-icon-button class="document-button view"
			[matTooltip]="'button.view' | translate" (click)="emitAction(onView)">
			<mat-icon class="m-0">visibility</mat-icon>
		</button>
		<button *ngIf="enableDownload" type="button" mat-icon-button class="document-button download"
			[matTooltip]="'button.download' | translate" (click)="emitAction(onDownload)">
			<mat-icon class="m-0">get_app</mat-icon>
		</button>
		<button *ngIf="enableEdit" type="button" mat-icon-button class="document-button edit"
			[matTooltip]="(editTooltip || 'button.edit') | translate" (click)="emitAction(onEdit)">
			<mat-icon class="m-0">edit</mat-icon>
		</button>
		<button *ngIf="enableDelete" type="button" mat-icon-button class="document-button delete"
			[matTooltip]="'button.delete' | translate" (click)="emitAction(onDelete)">
			<mat-icon class="m-0">close</mat-icon>
		</button>
	</div>
</div>
